import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './layout/components/header/header.component';
import { FooterComponent } from './layout/components/footer/footer.component';
import { PagesRoutingModule } from './pages-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ElencoProdottiComponent } from './elenco-prodotti/elenco-prodotti.component';
import { FormsModule } from '@angular/forms';
import { ConfermaOrdineComponent } from './conferma-ordine/conferma-ordine.component';
import { OrdineEseguitoComponent } from './ordine-eseguito/ordine-eseguito.component';
import { MatCardModule} from '@angular/material/card';
import { AddressDialogComponent } from './address-dialog/address-dialog.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingScreenInterceptor } from '../interceptor/loading.interceptor';
import { LoadingScreenComponent } from '../components/loading-screen/loading-screen.component';
import { RouterModule } from '@angular/router';
import { RecuperaPasswordComponent } from './auth/recupera-password/recupera-password.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { RecessoComponent } from './recesso/recesso.component';
import { InformativaComponent } from './informativa/informativa.component';
import { ModalSchedaProdComponent } from './modal-scheda-prod/modal-scheda-prod.component';
import { ModalSchedaProd2Component } from './modal-scheda-prod2/modal-scheda-prod2.component';
import { CambioPasswordComponent } from './profile/cambio-password/cambio-password.component';
import { MegaMenuModule } from 'primeng/megamenu';
import { HomeGruppiComponent } from './home-gruppi/home-gruppi.component';
import { HomeFamiglieComponent } from './home-famiglie/home-famiglie.component';
import { ImportOrdineComponent } from './profile/import-ordine/import-ordine.component';





@NgModule({
  declarations: [
    LayoutComponent,
    FooterComponent,
    HeaderComponent,
    AddressDialogComponent,
    LoadingScreenComponent,
    
    
    
    
    
    //ModalSchedaProdComponent,
    
    
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    NgbModule,
    FormsModule,
    MatCardModule,
    HttpClientModule,
    RouterModule,
    MegaMenuModule
    
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingScreenInterceptor,
    multi: true
  }],
  bootstrap: [LayoutComponent]
})
export class LayoutModule { }
